export default __webpack_public_path__ + "static/media/logo_white.953f3a71.svg";